import React from "react";

/**
 * Scholar — "Vår Lærde" section.
 * Big card with image holder on the left and profile text on the right.
 */
function Scholar() {
  return (
    <section className="scholar-section py-5">
      <div className="container">
        <h2 className="text-center mb-2" style={{ color: "#d4af37" }}>
          🌙 Vår Lærde
        </h2>
        <p className="text-center text-muted mb-5">
          Møt læreren som leder våre Quran-studier
        </p>

        <div className="scholar-card shadow-lg rounded-4 overflow-hidden">
          <div className="row g-0">
            {/* Image side */}
            <div className="col-md-5">
              <div className="scholar-image-holder d-flex align-items-center justify-content-center">
                <img
                  src="/images/Qari.JPG"
                  alt="Qari Sayed Farid"
                  style={{ width: "100%", maxWidth: "300px", height: "320px", objectFit: "cover", borderRadius: "10%" }}
                />
              </div>
            </div>

            {/* Text side */}
            <div className="col-md-7 d-flex align-items-center">
              <div className="p-4 p-md-5">
                <h3 className="fw-bold mb-1">Qari Sayed Farid</h3>
                <p className="text-gold fw-semibold mb-3">Quran- og Tajweed-lærer</p>
                <p className="text-muted mb-3">
                  Med over 15 års erfaring innen Quran-undervisning har vår lærde
                  hjulpet hundrevis av elever med å mestre tajweed og resitasjon.
                  Han har studert ved anerkjente islamske institusjoner og brenner
                  for å gjøre Quran-læring tilgjengelig for alle.
                </p>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge scholar-badge">🎓 15+ års erfaring</span>
                  <span className="badge scholar-badge">🌍 Norsk, persisk & Arabisk</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Scholar;
